import React from 'react';

import './Chef.css';
import { SubHeading } from '../../components';
import {images} from "../../constants"

const Chef = () => (
  <div className='app__bg app__wrapper section__padding'>
    <div className="app__wrapper_img app__wrapper_img-reverse">
      <img src = {images.chef} alt = "chef" />
    </div>

    <div className="app__wrapper_info">
      <SubHeading  title= "Founder's Word" />
      <h1 className="headtext__cormorant">What we Belive In</h1>
      <div className="app__chef-content">
        <div className="app__chef-content_quote">
         
          <p className="p__opensans">Kamatha was born from a love of Sri Lankan flavours and a desire to share the warmth of home style cooking with our Toongabbie community. Every dish tells a story from traditional family recipes to bold spices that reflect our heritage.</p>
        </div>
        <p className="p__opensans">We invite you to join us, experience our culture, and enjoy a truly authentic Sri Lankan meal.</p>
      </div>
      <div className="app__chef-sign">
        
        <p className="p__opensans">Kamatha Team</p>
        
      </div>
    </div>

  </div>
);

export default Chef;
